import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const IconCheckMarkWrapper = styled.span`
  width: 16px;
  height: 10px;
  margin-right: 8px;
`

export const ColorStyledSpan = styled.span`
  color: #1cb954;
  margin-left: auto;
`

export const GenresSelectItem = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #646877;
`

export const GenresSelectItemAnimation = styled(GenresSelectItem)`
  animation: fade 0.5s ease-in-out;
  display: flex;
  justify-content: flex-start;
`

export const Label = styled.span<{ isPlaceholder: boolean }>`
  display: block;
  color: ${({ isPlaceholder }) =>
    isPlaceholder ? colors.greyTextWhiteBg : colors.mainText};
`
